import type { FC } from 'react';

import classNames from 'classnames';

import { Typography } from 'src/app/components/Elements/Typography';

import styles from './styles.module.scss';

interface StaticPageProps {
  alignment?: 'left' | 'center';
  className?: string;
}

type DynamicPageProps =
  | {
      title: string;
      superTitle?: string;
      subtitle?: string;
    }
  | {
      title?: undefined;
      superTitle?: undefined;
      subtitle?: undefined;
    };

type PageProps = StaticPageProps & DynamicPageProps;

const Page: FC<PageProps> = ({ children, className, alignment, title, superTitle, subtitle, ...rest }) => {
  return (
    <div className={classNames(styles.contentWrap, styles[alignment!], className)} {...rest}>
      <div className={styles.content}>
        {title && (
          <>
            {superTitle && (
              <Typography variant={'overline'} color={'capsuleGreen60'}>
                {superTitle}
              </Typography>
            )}
            <Typography variant={'h1'} marginBottom={'s5'}>
              {title}
            </Typography>
            {subtitle && <Typography variant={'body'}>{subtitle}</Typography>}
          </>
        )}
        {children}
      </div>
    </div>
  );
};

export default Page;
